module.exports = __webpack_public_path__ + "static/media/portfolio6.61c5c504.jpg";